import { axiosInstance } from './base';
import { CheckoutPostResponse, CheckoutPostBody } from './models';

export const checkoutApi = {
  checkout: async (body: CheckoutPostBody): Promise<CheckoutPostResponse> => {
    const { data } = await axiosInstance.post('/api/v1/Payment/checkout', body);
    return data;
  },
};
